<script
    setup
    lang="ts"
>
defineProps({
  doubled: Boolean
})
</script>

<template>
  <svg
      v-if="doubled"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style="transform: rotate(180deg);"
  >
    <path
        d="M5.63574 7.75737L7.04996 6.34315L12.7068 12L7.04998 17.6568L5.63577 16.2426L9.87839 12L5.63574 7.75737Z"
        fill="currentColor"
    />
    <path
        d="M12.7068 6.34315L11.2926 7.75737L15.5352 12L11.2926 16.2426L12.7068 17.6568L18.3637 12L12.7068 6.34315Z"
        fill="currentColor"
    />
  </svg>
  <svg
      v-else
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      class="mt-icon"
      style="transform: rotate(180deg);"
  >
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.1722 12L8.22217 7.05L9.63617 5.636L16.0002 12L9.63617 18.364L8.22217 16.95L13.1722 12Z"
    />
  </svg>
</template>